import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { SalesunitComponent } from './salesunit.component';
import { SalesunitDetailComponent } from './salesunit-detail.component';
import { SalesunitPopupComponent } from './salesunit-dialog.component';
import { SalesunitDeletePopupComponent } from './salesunit-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class SalesunitResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const salesunitRoute: Routes = [
  {
    path: 'salesunit',
    component: SalesunitComponent,
    resolve: {
      'pagingParams': SalesunitResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.salesunit.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'salesunit/:id',
    component: SalesunitDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.salesunit.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const salesunitPopupRoute: Routes = [
  {
    path: 'salesunit-new',
    component: SalesunitPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.salesunit.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'salesunit/:id/edit',
    component: SalesunitPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.salesunit.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'salesunit/:id/delete',
    component: SalesunitDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.salesunit.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/salesunit/salesunit.route.ts